export const usdtTestAddress = "0xc2132d05d31c914a87c6611c10748aeb04b58e8f";
export const landsAddress = "0x2E831226b9D0dC9591e5EF3564B9C4529B2fa2e4";
export const landSaleAddress = "0x3F9141DBDFB7C5605bB807d1cD10d0b934Fb0453";
